import RadioChip from './RadioChip';
import styles from './RadioChipList.module.scss';

export interface RadioChips {
  imageUrl: string;
  name: string;
  id: number;
  onClick(): void;
}

export interface RadioChipListProps {
  radioChipItemsList: RadioChips[];
  selectedChipItem?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function RadioChipList({
  radioChipItemsList,
  selectedChipItem,
  onChange,
}: RadioChipListProps): JSX.Element {
  return (
    <div className={styles.wrapper}>
      <menu className={styles.choicesWrapper}>
        <hr className={styles.divider} />

        {radioChipItemsList.map((radioChipItem, index) => (
          <li
            key={radioChipItem.name}
            className={`${styles[`choiceArea${index + 1}`]} ${
              styles.choiceItem
            }`}
          >
            <RadioChip
              key={radioChipItem.name}
              imageUrl={radioChipItem.imageUrl}
              name={radioChipItem.name}
              value={radioChipItem.name}
              selected={radioChipItem.name === selectedChipItem}
              onClick={radioChipItem.onClick}
              onChange={onChange}
              data-testid="radioChip"
            />
          </li>
        ))}
      </menu>
    </div>
  );
}

export default RadioChipList;
